import React from 'react';

import type { TokenExchangeDTO } from '../../services/apiClient';
import { GoogleLogin } from '@react-oauth/google';

interface Props {
  setErrorMessage: (message: string | null) => void;
  handleGoogleSignIn: (dto: TokenExchangeDTO) => void;
}

const GoogleLoginButton: React.FC<Props> = ({
  setErrorMessage,
  handleGoogleSignIn,
}) => {
  const handleSuccess = async (response: any): Promise<void> => {
    handleGoogleSignIn({
      token: response.credential,
    });
  };

  return (
    <GoogleLogin
      onSuccess={handleSuccess}
      onError={() => setErrorMessage('Google Authentication failed.')}
    />
  );
};

export default GoogleLoginButton;
